export enum HealthStatus {
    HEALTHY = 0,
    UNKNOWN = 100,
    INFO = 200,
    WARNING = 300,
    ERROR = 400,
}
